export enum CloudItemType {
  Catalog = 'catalog',
  File = 'file',
}
